var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"con"},[_c('div',{staticClass:"contain"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"titBorder"}),_vm._v("\n            "+_vm._s(_vm.title)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"slotBox"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29a29671","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/haierProduct/components/my/common/detailBox.vue
// module id = null
// module chunks = 